import './Sidebar.scss';
import photo from '../assets/photo.jpg';
import back from '../assets/back.jpg';

import { usePage } from './PageContext';
import { useRef, useState } from 'react';

const Sidebar = () => {
    const clips = ["Software Engineer", "Actor"];

    const [flipped, setFlipped] = useState(1);
    const flipClicks = 5;
    const photoRef = useRef(null);
    const handleFlip = () => {
        if (flipped === flipClicks) {
            setFlipped(0);
            photoRef.current.style.setProperty("--rotation", "0deg");
        } else {
            photoRef.current.style.setProperty("--rotation", (flipped) + "deg");
            setFlipped((flipped + 1));
        }
        
    }

    const { setPage } = usePage();

    let enableClips = useRef(true);

    return (
        <div className="sidebar">
            <div className={("photo ") + (flipped ? "" : "flipped")} ref={photoRef}>
                <img className="front" src={photo} alt="Headshot of Benson" onClick={handleFlip} />
                <img className="back" src={back} alt="Headshot of Benson" onClick={handleFlip} />
            </div>
            <div className="clips">
                {
                    clips.map((text) => <div key={text} onClick={
                        (e) => {
                            // Don't change if we're not allowed to.
                            if (!enableClips.current) { return; }
                            // Prevent future changes for the next second.
                            enableClips.current = false;
                            setTimeout(() => {
                                enableClips.current = true;
                            }, 1000);
                            // Obtain the clip info from the click event.
                            const clipDiv = e.target;
                            const clipName = clipDiv.innerText;
                            // Change the global site page value.
                            setPage(clipName);
                        }
                    }>{text}</div>)
                }
            </div>
        </div>
    );
}

export default Sidebar;
